import React  from 'react'



export default function About(props) {

    // const [myStyle,setMyStyle]=useState(

    //     {
    //         color:'black' ,
    //         backgroundColor:'white'
    //     })
    let myStyle= {
      color:props.mode === 'light' ? 'black' : 'white',
      backgroundColor: props.mode === 'dark' ? '#568f56' : props.mode === 'red' ?'pink': props.mode === 'blue'?'purple':'white' ,
      border: '1px solid',
      borderColor:props.mode === 'light' ? 'black' : 'white'
    }
        
   return (
    <div className='container' >
        <h1 className='my-3' style={{color:props.mode === 'light' ? 'black' : 'white'}} > About Us</h1>
      <div className="accordion" id="accordionExample" style={myStyle}>
  <div className="accordion-item" style={myStyle}>
    <h2 className="accordion-header" >
      <button className="accordion-button" type="button" data-bs-toggle="collapse"  style={myStyle} data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" >
      Introduction
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample" >
      <div className="accordion-body" style={myStyle}>
        This is Textediting appp that can perform various action on provided words.
      </div>
    </div>
  </div>
  <div className="accordion-item" style={myStyle}>
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
      Our works
      </button>
    </h2>
    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body" style={myStyle}>
       We perform action like UpperCase , LowerCase ,clearText,Speak and clear text as well content can be copied to clipborad.
      </div>
    </div>
  </div>
  <div className="accordion-item" style={myStyle}>
    <h2 className="accordion-header">
      <button className="accordion-button collapsed "  style={myStyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
     Help-line
      </button>
    </h2>
    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body " style={myStyle}>
       Contact us for adding more services.
      </div>
    </div>
  </div>
</div> 

    </div>
  )
}

